import type { IconProps } from '../types/IconProps.ts';
export const CircleCheckBig: IconProps = {
    name: 'CircleCheckBig',
    children: [
        `<path d="M21.54 9A10 10 0 1 1 15 2.46" />`,
        `<path d="m9.5 10.5 2.23 1.85a1 1 0 0 0 1.44-.23L21 3" />`,
    ]
};